import React, { useEffect } from "react";
import "./styles.css";
import Horarios from "../Horarios/Horarios";
import Ubicacion from "../Ubicacion/Ubicacion";
import { Link } from "react-router-dom";
import RedesSociales from "../RedesSociales/RedesSociales";
import { IconScissors, IconStar, IconClock, IconImage } from "../icons/Icons";
import { resolveApiBase } from "../../api/client";

function MainPage() {
    useEffect(() => {
        // Comprueba qué servidor de reservas responde (.es primero, ddns de respaldo)
        resolveApiBase();
    }, []);

    return (
        <div id="page-container">
            <div id="content-wrap">
                <header>
                    <span className="header-title">SUBLIME HAIR SALON</span>
                    <a
                        href="https://wa.me/640997403"
                        target="_blank"
                        rel="noopener noreferrer"
                        id="whatsapp-link"
                        aria-label="Contactar por WhatsApp"
                    >
                        <svg className="wa-icon" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="24" cy="24" r="22" fill="none" stroke="#fff" strokeWidth="1.3"/>
                            <path transform="translate(12.6,11) scale(0.0508)" fill="#fff" d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l119.7-31.4c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-156.9zM223.9 438.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-71 18.6 19-69.2-4.4-7.1c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
                        </svg>
                    </a>
                </header>

                <main id="content">
                    <section id="hero">
                        <div className="hero-content">
                            <h1 className="hero-title">SUBLIME HAIR SALON</h1>
                            <div className="separator"></div>
                            <p className="hero-subtitle">• Cada cliente, una experiencia •</p>
                            <p className="hero-subtitle-italic">Inspiring confidence every day</p>
                            <div className="separator"></div>
                            <p className="hero-tagline">tu mejor versión empieza aquí</p>
                            <Link to="/reservas" className="cta-link">
                                <button className="cta-button">RESERVA TU CITA</button>
                            </Link>
                            <div className="chevron-container">
                                <svg className="chevron" viewBox="0 0 24 12" xmlns="http://www.w3.org/2000/svg">
                                    <polyline points="2,2 12,10 22,2" fill="none" stroke="white" strokeWidth="1.5"/>
                                </svg>
                                <svg className="chevron" viewBox="0 0 24 12" xmlns="http://www.w3.org/2000/svg">
                                    <polyline points="2,2 12,10 22,2" fill="none" stroke="white" strokeWidth="1.5"/>
                                </svg>
                            </div>
                        </div>

                        <div className="hero-cards">
                            <Link to="/servicios" className="hero-card">
                                <IconScissors className="card-icon" />
                                <span className="card-label">SERVICIOS<br/>Y PRECIOS</span>
                                <span className="card-arrow">&rarr;</span>
                            </Link>
                            <Link to="/vip" className="hero-card">
                                <IconStar className="card-icon" />
                                <span className="card-label">SERVICIOS<br/>VIP</span>
                                <span className="card-arrow">&rarr;</span>
                            </Link>
                            <Link to="/citas-especiales" className="hero-card">
                                <IconClock className="card-icon" />
                                <span className="card-label">CITAS FUERA<br/>DE HORARIO</span>
                                <span className="card-arrow">&rarr;</span>
                            </Link>
                            {/* Oculto de momento
                            <Link to="/trabajos" className="hero-card">
                                <IconImage className="card-icon" />
                                <span className="card-label">TRABAJOS<br/>REALIZADOS</span>
                                <span className="card-arrow">&rarr;</span>
                            </Link>
                            */}
                        </div>
                    </section>
                    <Horarios />
                    <Ubicacion />
                </main>
            </div>
            <footer>
                <RedesSociales />
            </footer>
        </div>
    );
}

export default MainPage;
